import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getTasks(project, resource) {
      const res = getState().find(
        (r) =>
          r.project.uuid === project.uuid && r.resource.uuid === resource.uuid,
      );
      return res ? res.tasks : [];
    },
    isTasksRetrievalRequestPending(project, resource) {
      const res = getState().find(
        (r) =>
          r.project.uuid === project.uuid && r.resource.uuid === resource.uuid,
      );
      return res ? res.request.isPending : false;
    },
    isTasksRetrievalRequestSuccess(project, resource) {
      const res = getState().find(
        (r) =>
          r.project.uuid === project.uuid && r.resource.uuid === resource.uuid,
      );
      return res ? res.request.isSuccessful : false;
    },
    isTasksRetrievalRequestFailure(project, resource) {
      const res = getState().find(
        (r) =>
          r.project.uuid === project.uuid && r.resource.uuid === resource.uuid,
      );
      return res ? res.request.isFailure : false;
    },
  };
}

export { createSelector };
